import Collection from 'lib/Collection';
import Zone from 'model/Zone';
import config from 'config';
import * as repo from 'db/repositories';


export default Collection.extend({
	model: Zone,
	comparator: 'code',

	// Chargement des données depuis l'API ou depuis un fichier local
	url: config.url.zone,
	file: config.file.zone,

	toString: function() {
		return 'liste des départements';
	},

	/**
	 * Zone la plus proche (async → Promise<Zone|null>).
	 * Préfiltre AABB Dexie/index puis Turf.
	 */
	getClosest: function( position )
	{
		return repo.getClosestZone( position );
	},

	/**
	 * Recherche par CP via index mémoire (sync).
	 * @returns {string|null} id zone
	 */
	findByZip: function( zip )
	{
		var id = repo.findByZip( zip );
		if( !id )
		{
			return null;
		}

		// Modèle minimal pour les callers qui testent la vérité
		return new Zone( { id: id } );
	},

	get: function( id )
	{
		// Fallback collection vide + lookup async non supporté ici
		var found = Backbone.Collection.prototype.get.call( this, id );
		if( found )
		{
			return found;
		}

		return null;
	},
});
